import { observer } from 'mobx-react';
import React from 'react';

import DropIndicator from 'components/UI/DropIndicator';
import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import AssetsDrawerHeader from './AssetsDrawerHeader';
import AssetSummaryRow from './AssetSummaryRow';

function AssetsDrawer() {
  const store_creative = store.creative;

  // Creative.tsx already guards this whole subtree, so this is unreachable
  // today. Stated here anyway so the requirement is local to the component
  // rather than implied by an ancestor - and because the alternative, a `?.` on
  // each read, would claim these three values can go missing independently when
  // they are all the same one condition.
  if (!store_creative) return null;

  const fileDragging = store.ui.fileDragging;
  const currentFolderContents = store_creative.assets.folderContext;

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  return (
    <DrawerLayout
      onClose={handleOnClose}
      title={<AssetsDrawerHeader />}
      open={store_creative.displayPanel === PanelViews.ASSETS}
    >
      <DropIndicator visible={fileDragging} />
      {currentFolderContents.map((asset) => (
        <AssetSummaryRow asset={asset} key={asset.id} />
      ))}
    </DrawerLayout>
  );
}

export default observer(AssetsDrawer);
